import React, { useState } from 'react';
import { intl, havePermissions } from "dmsbasereact";
import {
    IconButton,
    Tooltip,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { DmsReturnEditModal } from '../DmsReturnEditModal/DmsReturnEditModal';
import { ReturnStatusEnum } from '../../constants/ReturnStatus';
import { Permissions } from '../../constants/Permissions';

export const DmsReturnEditButton = ({ row, table, managementMode = false }) => {
    const [show, setShow] = useState(false);

    const statusValue = typeof row?.status === 'object' ? row?.status?.value : row?.status;
    const isCompleted = statusValue === ReturnStatusEnum.COMPLETED;
    const isCollected = statusValue === ReturnStatusEnum.COLLECTED;
    const isEurofarmaUser = havePermissions([Permissions.EUROFARMA_MANAGEMENT]);
    const isDisabled = !row || !row.pk || ((isCompleted || isCollected) && !isEurofarmaUser);

    const getTooltipText = () => {
        if (isCollected && !isEurofarmaUser) {
            return intl.get("ReturnCollectedCannotEdit").d("Collected returns cannot be edited");
        }
        if (isCompleted && !isEurofarmaUser) {
            return intl.get("ReturnCompletedCannotEdit").d("Completed returns cannot be edited");
        }
        return intl.get("EditReturn").d("Edit Return");
    };

    return (
        <>
            <Tooltip title={getTooltipText()}>
                <span>
                    <IconButton
                        onClick={() => setShow(true)}
                        color="primary"
                        disabled={isDisabled}
                    >
                        <EditIcon />
                    </IconButton>
                </span>
            </Tooltip>

            {show && (
                <DmsReturnEditModal
                    show={show}
                    onHide={() => setShow(false)}
                    row={row}
                    table={table}
                    managementMode={managementMode}
                />
            )}
        </>
    );
};